
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import MaterialTable from "material-table"
import { GetPayrollSettingsAction } from "../../../../../store/Finance/PayRollTemplate/Action";
import { useEffect } from "react";

const PTLandingPage = () => {
    const dispatch = useDispatch()
    const { payroll_setting_component_data, isLoading } = useSelector(
        (state) => state?.FinanceReducer.PayrollTemplateReducer
    );
    useEffect(() => {
        dispatch(GetPayrollSettingsAction({ component_type: "PT" }))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <Box sx={{ mt:2}}>
            <MaterialTable
             isLoading={isLoading}
                columns={[
                    { title: "State Name", cellStyle: { padding: "10px 10px 10px 13px" }, field: "state_name" },
                    { title: "Region", cellStyle: { padding: "10px 10px 10px 13px" }, field: "region" },
                    { title: "Deduction Frequency", cellStyle: { padding: "10px 10px 10px 13px" }, field: "frequency" },
                    { title: "Half Yearly Min Amount", cellStyle: { padding: "10px 10px 10px 13px" }, field: "min_range" },
                    { title: "Half Yearly Max Amount", cellStyle: { padding: "10px 10px 10px 13px" }, field: "max_range",
                        render: rowData => {
                            const maxSalary = rowData?.max_range;
                            const crore = 10000000;
                            return maxSalary > crore ? "MAX" : maxSalary?.toLocaleString();
                    }
                    },
                    { title: "PT Amount / Month", cellStyle: { padding: "10px 10px 10px 13px" }, field: "round" },
                ]}
                data={payroll_setting_component_data?.[0]?.fn_get_payroll_settings_components || []}
                options={{
                    maxBodyHeight: "calc(100vh - 205px)",
                    rowStyle: { fontSize: "13px" },
                    headerStyle: { padding: "5px 10px", fontWeight: "bold" },
                    sorting: true,
                    search: false,
                    searchFieldAlignment: "right",
                    searchAutoFocus: true,
                    searchFieldVariant: "standard",
                    filtering: false,
                    paging: false,
                    selection: false,
                    actionsColumnIndex: -1,
                    grouping: false,
                    addRowPosition: "first",
                }}
                title=""
            />
        </Box>
    );
}
export default PTLandingPage;